var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full-screen-container",style:({height: _vm.maxHeightStyle, maxHeight: _vm.maxHeightStyle})},[_vm._t("default",null,{"height":_vm.maxHeight - 10})],2)}
var staticRenderFns = []

export { render, staticRenderFns }